// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","header":"J5kkGYLpnJrw7Pe2sgJfU"};